exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-expansion-panel[data-v-03b8888e] button{padding-left:18px!important}.v-expansion-panel-content[data-v-03b8888e] .v-expansion-panel-content__wrap{padding-top:0!important;padding-bottom:0!important}", ""]);

// exports
